import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { settingsPageStyles } from "component/shared/settings-page";

export const styles = (theme: Theme) => {
	return ({
		...settingsPageStyles(theme),
		// Listing Alerts options stack, 24px apart (MAX-4355).
		stackedOptions: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			gap: 24,
		},
		checkboxOption: {
			alignItems: "flex-start",
			// Centre the checkbox on the bold title line (24px), not the title + description block (MAX-4355).
			"& .MuiCheckbox-root": {
				paddingTop: 0,
			},
		},
		checkboxTitle: {
			fontWeight: "bold",
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		checkboxDescription: {
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
			marginTop: 2,
		},
		// Figma indents everything the Email Copies toggle discloses.
		disclosed: {
			marginLeft: 64,
			marginTop: 16,
		},
		copiesLabel: {
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
			marginBottom: 8,
		},
		divider: {
			marginTop: 24,
			marginBottom: 24,
		},
	} satisfies Record<string, CSSObject>);
};
